// extracted by css-extract-rspack-plugin
export default {"spinnerWrapper":"_8c4c56af"};